import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import AppLogout from "../components/timeOutAlert";
import { USERS_TYPE } from "../data/Constants";

const AtpProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);

  return user && user.user_type === USERS_TYPE.ATP_USER ? (
    <AppLogout>{children}</AppLogout>
  ) : (
    <Navigate to="/atp/login" replace />
  );
};

export default AtpProtectedRoute;
